import { useEffect, useState } from 'react';

/**
 * Returns a copy of `value` that updates only after `delay` ms of stability.
 * Useful for debouncing live preview requests as the user edits a form.
 */
export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = window.setTimeout(() => setDebounced(value), delay);
    return () => window.clearTimeout(id);
  }, [value, delay]);
  return debounced;
}
